import React from 'react';
import useSearchParams from '../../../util/useSearchParams';
import OrgUnitEditorPage from '../OrganizationalUnit/editor/OrgUnitEditorPage';
import OrgUnitInstitutionsTable from './OrgUnitInstitutionsTable';

function OrgUnitInstitutions() {
  const [[institution, setInstitution]] = useSearchParams({
    institution: undefined as string | undefined,
  });

  if (institution) return <OrgUnitEditorPage context="institutions" orgUnitId={institution} setOrgUnitId={setInstitution} />;

  return <OrgUnitInstitutionsTable setOrgUnit={setInstitution} />;
}

export default OrgUnitInstitutions;
